import { supabase } from "../../config/supabase";

// Update a challenge
const updateChallenge = async (challengeId,title = '',description = '',duration = 60) => {
    try {
        const updatedChallenge = {
            title:title.toLowerCase(),
            description:description.toLowerCase(),
            duration
        }
        const { error } = await supabase.from('challenges').update(updatedChallenge).eq('challenge_id', challengeId);
        if (error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in updating challenges:',err);
        return { error: err };
    }
};

export { updateChallenge };